import { useState } from "react";
import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { LlmInfo } from "../models/LlmInfo";

export const useUpdateLlm = () => {
  const { data, isLoading, isFailed, call } = useApiPrivateRequest<void>();
  const [isUpdated, setIsUpdated] = useState(false);

  const updateLlm = async (llmName: string, llmData: Partial<LlmInfo>) => {
    setIsUpdated(false);
    await call(`/admin/llm/${llmName}`, "PUT", undefined, llmData);
    if (!isFailed) {
      setIsUpdated(true);
    }
  };

  return {
    updateLlm,
    isUpdated,
    isLoading,
    isFailed,
    data,
  };
};
